const ENGLISH_FAQ_TITLE = /^frequently asked questions$/i;

export const isEnglishFaqTitle = (title: string): boolean =>
  ENGLISH_FAQ_TITLE.test(title.trim());

export const localizeFaqTitle = (
  title: string | undefined,
  translatedFaqTitle: string,
): string | undefined => {
  if (!title) return title;
  return isEnglishFaqTitle(title) ? translatedFaqTitle : title;
};
